// 사용자 관리 API
import axiosInstance from './axiosInstance';

export const getUsers = () =>
  axiosInstance.get('/users').then(r => r.data);

export const createUser = (body) =>
  axiosInstance.post('/users', body).then(r => r.data);

export const getUserDetail = (userId) =>
  axiosInstance.get(`/users/${userId}/detail`).then(r => r.data);

export const getLoginHistory = (userId, page = 1, limit = 20) =>
  axiosInstance.get(`/users/${userId}/login-history`, { params: { page, limit } }).then(r => r.data);

export const getAgreeHistory = (userId) =>
  axiosInstance.get(`/users/${userId}/agree-history`).then(r => r.data);

export const updateUser = (userId, body) =>
  axiosInstance.put(`/users/${userId}`, body).then(r => r.data);

export const approveUser = (userId) =>
  axiosInstance.put(`/users/${userId}/approve`).then(r => r.data);

export const deactivateUser = (userId) =>
  axiosInstance.put(`/users/${userId}/deactivate`).then(r => r.data);

export const resetPassword = (userId) =>
  axiosInstance.put(`/users/${userId}/reset-password`).then(r => r.data);

export const deleteUser = (userId) =>
  axiosInstance.delete(`/users/${userId}`).then(r => r.data);

export const getUserPermissions = (userId) =>
  axiosInstance.get(`/users/${userId}/permissions`).then(r => r.data);

export const saveUserPermissions = (userId, permissions) =>
  axiosInstance.post(`/users/${userId}/permissions`, { permissions }).then(r => r.data);

export const signup = (body) =>
  axiosInstance.post('/auth/signup', body).then(r => r.data);

export const changePassword = (oldPassword, newPassword) =>
  axiosInstance.post('/auth/change-password', {
    old_password: oldPassword,
    new_password: newPassword,
  }).then(r => r.data);
